import "./footer.css"
import logo from "../../assets/logo.svg"
import React from "react";

function Footer() {
    return (
        <div className="footer">
            <div className="footer_content">
                <div>
                    <a
                        href="https://www.choicetrade.com/"
                        aria-label="logo"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            className="footer_logo"
                            width="auto" height="auto"
                            src={logo} alt=""
                        />
                    </a>
                    <p className="footer_text text-white md:text-base text-xs font-medium xl:pt-7 pt-2 sm:w-22rem w-auto">
                        Copyright 2000-{new Date().getFullYear()} ChoiceTrade. All rights reserved Member FINRA and
                        <a
                            className="no-underline"
                            style={{color: "#0264AC"}}
                            target="_blank"
                            href="https://www.sipc.org/"
                            rel="noreferrer"
                        > SIPC</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer